import Router from '@koa/router'
import * as ctrl from '../../controllers/hermes/sessions'

export const sessionRoutes = new Router()

sessionRoutes.get('/api/hermes/sessions/conversations', ctrl.listConversations)
sessionRoutes.get('/api/hermes/sessions/conversations/:id/messages', ctrl.getConversationMessages)
sessionRoutes.get('/api/hermes/sessions/conversations/:id/messages/paginated', ctrl.getConversationMessagesPaginated)
sessionRoutes.get('/api/hermes/sessions', ctrl.list)
sessionRoutes.post('/api/hermes/sessions', ctrl.create)
sessionRoutes.get('/api/hermes/sessions/count', ctrl.count)
sessionRoutes.get('/api/hermes/sessions/hermes', ctrl.listHermesSessions)
sessionRoutes.get('/api/hermes/sessions/hermes/:id', ctrl.getHermesSession)
sessionRoutes.post('/api/hermes/sessions/hermes/:id/import', ctrl.importHermesSession)
sessionRoutes.get('/api/hermes/search/sessions', ctrl.search)
sessionRoutes.get('/api/hermes/sessions/search', ctrl.search)
sessionRoutes.get('/api/hermes/sessions/usage', ctrl.usageBatch)
sessionRoutes.get('/api/hermes/usage/stats', ctrl.usageStats)
sessionRoutes.get('/api/hermes/sessions/context-length', ctrl.contextLength)
sessionRoutes.get('/api/hermes/sessions/:id/context', ctrl.getContext)
sessionRoutes.get('/api/hermes/sessions/:id/workspace-run-changes', ctrl.listWorkspaceRunChanges)
sessionRoutes.get('/api/hermes/sessions/:id/workspace-run-changes/:changeId/files/:fileId', ctrl.getWorkspaceRunChangeFile)
sessionRoutes.get('/api/hermes/sessions/:id/workspace-file/read', ctrl.readWorkspaceFile)
sessionRoutes.put('/api/hermes/sessions/:id/workspace-file/write', ctrl.writeWorkspaceFile)
sessionRoutes.get('/api/hermes/sessions/:id', ctrl.get)
sessionRoutes.get('/api/hermes/sessions/:id/export', ctrl.exportSession)
sessionRoutes.get('/api/hermes/sessions/:id/usage', ctrl.usageSingle)
sessionRoutes.delete('/api/hermes/sessions/:id', ctrl.remove)
sessionRoutes.post('/api/hermes/sessions/batch-delete', ctrl.batchRemove)
sessionRoutes.post('/api/hermes/sessions/:id/rename', ctrl.rename)
sessionRoutes.post('/api/hermes/sessions/:id/archive', ctrl.archive)
sessionRoutes.post('/api/hermes/sessions/:id/unarchive', ctrl.unarchive)
sessionRoutes.post('/api/hermes/sessions/:id/workspace', ctrl.setWorkspace)
sessionRoutes.post('/api/hermes/sessions/:id/model', ctrl.setModel)
sessionRoutes.get('/api/hermes/workspace/folders', ctrl.listWorkspaceFolders)
sessionRoutes.post('/api/hermes/workspace/folders', ctrl.createWorkspaceFolder)
sessionRoutes.post('/api/hermes/workspace/folders/rename', ctrl.renameWorkspaceFolder)
sessionRoutes.delete('/api/hermes/workspace/folders', ctrl.deleteWorkspaceFolder)
